import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const MainEventsService = {
  async getMainEvents(page, perPage) {
    const params = generateQueryParams({ page, size: perPage });

    const res = await axios.get('org/v1/mainEvents/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createMainEvent(payload) {
    const res = await axios.post('org/v1/mainEvents/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteMainEvent(id) {
    const res = await axios.delete(`org/v1/mainEvents/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateMainEvent(payload, id) {
    const res = await axios.put(`org/v1/mainEvents/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
